import { FC } from "react";

import { Box, VStack, HStack } from "@chakra-ui/react";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faGavel } from "@fortawesome/free-solid-svg-icons";
import { Skeleton } from "antd";
import useTopActiveListings from "hooks/useTopActiveListings";
import { useIdentity } from "context/auth";

const ActiveListingsCount: FC = () => {
    const { accounts } = useIdentity();
    const { data: topActiveListings, isLoading: isTopActiveListingsLoading } =
        useTopActiveListings(accounts[0]);

    return (
        <>
            <HStack spacing={1}>
                <Box fontWeight="semibold" fontSize={18}>
                    Listings
                </Box>
                <Box color="#9ca3af" fontWeight="semibold">
                    - Active
                </Box>
            </HStack>
            <VStack spacing={0}>
                <HStack justifyContent="center">
                    <FontAwesomeIcon icon={faGavel} size="2xl" />
                    <Box fontSize="clamp(32px, 2.5vw, 52px)">
                        {isTopActiveListingsLoading ? (
                            <Skeleton.Input active />
                        ) : (
                            topActiveListings?.totalRecords
                        )}
                    </Box>
                </HStack>
            </VStack>
            <Box justifyContent="right" display="flex" width="100%">
                <Box backgroundColor="darkGray" px={2} py={1} borderRadius="md">
                    See all listings
                </Box>
            </Box>
        </>
    );
};

export default ActiveListingsCount;
